import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Voices from './pages/Voices';

// Public Pages
import PublicForm from './pages/PublicForm';
import FacialCaptureRedirect from './pages/FacialCaptureRedirect';
import SSRFormRedirect from './pages/SSRFormRedirect';
import AccessControl from './pages/AccessControl';
import PhotoMosaic from './pages/PhotoMosaic';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import DynamicTerms from './pages/DynamicTerms';
import DynamicPrivacy from './pages/DynamicPrivacy';
import PhotoBoothPanel from './pages/PhotoBoothPanel';
import PhotoBoothDisplay from './pages/PhotoBoothDisplay';
import PhotoBoothMural from './pages/PhotoBoothMural';

// Components
import PrivateRoute from './components/PrivateRoute';
import Loading from './components/Loading';

function App() {
  const { loading } = useAuth();

  if (loading) {
    return <Loading fullScreen />;
  }

  return (
    <ToastProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/form/:slug" element={<PublicForm />} />
          <Route path="/:slug/f/registro" element={<SSRFormRedirect />} />
          <Route path="/form/:slug/facial" element={<FacialCaptureRedirect />} />
          <Route path="/access/:projectId" element={<AccessControl />} />
          <Route path="/mosaic/:projectId" element={<PhotoMosaic />} />
          <Route path="/terminos" element={<Terms />} />
          <Route path="/terminos/:slug" element={<DynamicTerms />} />
          <Route path="/privacidad" element={<Privacy />} />
          <Route path="/privacidad/:slug" element={<DynamicPrivacy />} />
          
          {/* PhotoBooth con token diario (acceso público) */}
          <Route path="/photobooth/:slug/panel/:token" element={<PhotoBoothPanel />} />
          <Route path="/photobooth/:slug/tv/:token" element={<PhotoBoothDisplay />} />
          <Route path="/photobooth/:slug/mural/:token" element={<PhotoBoothMural />} />
          
          {/* PhotoBooth legacy (redirecciona a versión con token) */}
          <Route path="/photobooth/:slug" element={<PhotoBoothPanel />} />
          <Route path="/photobooth/:slug/tv" element={<PhotoBoothDisplay />} />
          <Route path="/photobooth/:slug/mural" element={<PhotoBoothMural />} />

          {/* Private Routes */}
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute permission="users"><Users /></PrivateRoute>} />
          <Route path="/projects" element={<PrivateRoute permission="forms"><Projects /></PrivateRoute>} />
          <Route path="/projects/:id" element={<PrivateRoute permission="forms"><ProjectDetail /></PrivateRoute>} />
          <Route path="/voices" element={<PrivateRoute permission="voices"><Voices /></PrivateRoute>} />

          {/* Redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
